import React, { SyntheticEvent, useEffect, useState } from 'react'
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/UserPanel';
import './Header.scss';
import { Template } from 'devextreme-react/core/template';
import { ThemeSwitcher } from '../theme-switcher/ThemeSwitcher';
import type { HeaderProps } from '../../types';

import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'

import MuiDialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { Typography } from '@mui/material';
import MuiAutocomplete, { AutocompleteRenderInputParams } from '@mui/material/Autocomplete'
import { styled, useTheme } from '@mui/material/styles'
import GlobalCommandPalette from '../../layouts/component/GlobalCommandPallete'

export default function Header({ menuToggleEnabled, title, toggleMenu }: HeaderProps) {


  return (
    <>
      <header className={'header-component'}>
        <Toolbar className={'header-toolbar'}>
          <Item
            visible={menuToggleEnabled}
            location={'before'}
            widget={'dxButton'}
            cssClass={'menu-button'}
          >
            <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
          </Item>
          <Item
            location={'before'}
            cssClass={'header-title'}
            text={title}
            visible={!!title}
          />
          <Item
            location={'before'}
          >
            <div>
              <Button
              stylingMode='text'
              icon={'search'}
              text="Search ( CTRL + / )"
              onClick={() => {
              // Simulate Ctrl + / keypress
              const event = new KeyboardEvent('keydown', {
                key: '/',
                code: 'Slash',
                ctrlKey: true,
                bubbles: true
              });
              document.dispatchEvent(event);
              }}
              elementAttr={{
              style: {
              color: '#9ca3af'
              }
              }}
              />
            </div>
          </Item>
          <Item
            location={'after'}
          >
            <ThemeSwitcher />
          </Item>
          <Item location='after' locateInMenu='auto' menuItemTemplate='userPanelTemplate'>
            <UserPanel menuMode='context' />
          </Item>
          <Template name='userPanelTemplate'>
            <UserPanel menuMode='list' />
          </Template>
        </Toolbar>
        <GlobalCommandPalette />
      </header>
    </>
  )
}
